export default "__VITE_ASSET__BB20cH_J__"